import React from 'react';
import { bool, oneOf, oneOfType, node, string } from 'prop-types';
import AlertText from '@magalu/stereo-ui/molecules/AlertText';
import { Flex } from '@magalu/stereo-ui/atoms';

const WarningText = ({
  showAlert,
  message,
  icon,
  alignment
}) => {
  if (showAlert) return /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    justifyContent: alignment
  }, /*#__PURE__*/React.createElement(AlertText, {
    "data-testid": "warning-text",
    message: message,
    intent: "warning",
    icon: icon,
    styleContainer: {
      maxWidth: 'max-content'
    }
  }));
  return null;
};

WarningText.defaultProps = {
  showAlert: false,
  message: '',
  icon: '',
  alignment: 'center'
};
process.env.NODE_ENV !== "production" ? WarningText.propTypes = {
  showAlert: bool,
  message: string,
  icon: oneOfType([node, string]),
  alignment: oneOf(['center', 'start', 'end'])
} : void 0;
export default WarningText;